// 진입점 + 라우팅 (기획서 11장)
// 정적 사이트 — 해시 라우팅. #/ = 라이브러리, #/reader/:id = 뷰어 (기획서 9.2)
import { openDB } from './db/schema.js';
import { loadSettings, saveSettings } from './db/settings.js';
import { LibraryView } from './views/library.js';
import { ViewerView } from './views/viewer.js';
import { toast } from './utils/toast.js';

const appRoot = document.getElementById('app');
let currentView = null;
let settings = null;

async function boot() {
  try {
    await openDB();
  } catch (err) {
    console.error(err);
    appRoot.innerHTML =
      '<div style="padding:40px;text-align:center;line-height:1.7">' +
      '브라우저 저장소(IndexedDB)를 열 수 없습니다.<br/>' +
      '시크릿 모드이거나 저장소가 차단되었을 수 있습니다.</div>';
    return;
  }
  settings = await loadSettings();
  window.addEventListener('hashchange', route);
  route();
}

function teardownCurrent() {
  if (currentView && typeof currentView.unmount === 'function') {
    currentView.unmount();
  }
  currentView = null;
  appRoot.innerHTML = '';
}

async function route() {
  const hash = window.location.hash || '#/';
  const m = hash.match(/^#\/reader\/(.+)$/);

  teardownCurrent();

  if (m) {
    const bookId = decodeURIComponent(m[1]);
    currentView = new ViewerView(appRoot, {
      bookId,
      settings,
      onBack: () => {
        window.location.hash = '#/';
      },
      onSettingsChange: async (next) => {
        settings = await saveSettings(next);
      },
    });
    try {
      await currentView.mount();
    } catch (err) {
      console.error(err);
      toast('책을 열지 못했습니다.');
      window.location.hash = '#/';
    }
  } else {
    currentView = new LibraryView(appRoot, {
      onOpenBook: (id) => {
        window.location.hash = `#/reader/${encodeURIComponent(id)}`;
      },
    });
    await currentView.mount();
  }
}

boot();
